<aside class="w-full h-100vh" aria-label="Sidebar">
    <div class="overflow-y-auto rounded bg-gray-50 h-full">
        <div *ngIf="clientDetails$ | async as clientDetails"
            class="flex flex-col justify-center p-6 ">
            <img loading="lazy"  [src]="clientDetails.basicInfo.imagePath || '../../../../assets/images/profile.png'" alt="user"
                class="w-24 h-24 mx-auto rounded-full dark:bg-gray-500 aspect-square">
            <div class="space-y-4 text-center divide-y dark:divide-gray-300">
                <div class="my-2 space-y-1">
                    <h4 class="text-xl font-medium sm:text-2xl">{{clientDetails.basicInfo.name}}</h4>
                </div>
            </div>
        </div>
        <ul class="space-y-2 m-0 p-0">
            <li *ngFor="let item of listOfLinks">
                <a href="javascript:void(0)"
                    (click)="navigateToProfile(item.path)"
                    class="flex items-center p-3 text-base font-normal text-gray-900 hover:bg-primary-300 ">
                    <span class="flex-1 ml-3 whitespace-nowrap">{{item.name | translate}}</span>
                    <span class="inline-flex items-center justify-center px-2 ml-3 text-sm font-medium text-gray-800">
                        <i class="fa" [class]="translate.currentLang == 'en' ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
                    </span>
                </a>
            </li>
            <hr>
            <!-- <li>
                <a href="javascript:void(0)" 
                (click)="navigateToProfile('/profile/my-appointment')"
                    class="flex items-center p-3 text-base font-normal text-gray-900 hover:bg-primary-300 ">
                    <span class="flex-1 ml-3 whitespace-nowrap">test</span>
                    <span class="inline-flex items-center justify-center px-2 ml-3 text-sm font-medium text-gray-800">
                        <i class="fa" [class]="translate.currentLang == 'en' ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
                    </span>
                </a>
            </li>
            <li>
                <a href="javascript:void(0)"
                    class="flex items-center p-3 text-base font-normal text-gray-900 hover:bg-primary-300 ">

                    <span class="flex-1 ml-3 whitespace-nowrap">test</span>
                    <span class="inline-flex items-center justify-center px-2 ml-3 text-sm font-medium text-gray-800">
                        <i class="fa" [class]="translate.currentLang == 'en' ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
                    </span>
                </a>
            </li> -->
            <li (click)="logOut()">
                <a href="javascript:void(0)"
                    class="flex items-center p-3 text-base font-normal text-red-500 hover:text-red-700">
                    <span class="flex-1 ml-3 whitespace-nowrap">{{'menu.logout' | translate}}</span>
                </a>
            </li>
        </ul>
    </div>
</aside>